// extracted by mini-css-extract-plugin
module.exports = {"xs_only":"only screen and (max-width: 767px)","body":"modal_container__body__R0poC overflow__overflow_hidden__r4HZ3"};